export default __webpack_public_path__ + "static/media/loader.c874f3bc.svg";